import React from 'react'
import { DefaultLayout } from '../../layouts'
import { PageHeader, ContentNav } from './components'
import { Container, Loader } from '../../components'
import { useDispatch, useSelector } from 'react-redux'
import { useViewport } from '../../utils'
import { Route } from 'react-router-dom'
import { DetailAbout, DetailMember } from './routes'
import { OrganizationProvider } from '../../features/organization/hook'
import { fetchOrganization } from '../../features/organization/slice'
import { DetailProgram } from './routes/program.v1'
import { DetailBlog } from './routes/blog.v1'
import { DetailEvent } from './routes/event.v1'
import { DetailResource } from './routes/resource.v1'
import styles from './organization-detail.module.css'

const OrganizationDetail = (props) => {
  const dispatch = useDispatch()
  const { match } = props
  const organizationId = match.params.id
  const organization = useSelector(state => state.organizations.page_organization_detail_data)
  const { isDesktop } = useViewport()
  const status = useSelector(state => state.organization.status)

  React.useEffect(() => {
    dispatch(fetchOrganization(organizationId))
    // eslint-disable-next-line
  }, [organizationId])

  return (
    <DefaultLayout>
      {
        status === 'loading' &&
        <div className="flex items-center justify-center py-10">
          <Loader />
        </div>
      }
      <OrganizationProvider id={organizationId}>
        <PageHeader />
        {
          isDesktop ? (
            <Container className="pt-8 hidden lg:block">
              <div className="border-b">
                <ContentNav organization={organization}/>
              </div>
            </Container>
          ) : (
            <div className={`border-b mb-5 lg:hidden ${styles['content-nav-wrapper']}`}>
              <ContentNav organization={organization} mobile/>
            </div>
          )
        }

        <Route path="/organization/:id/member">
          <DetailMember />
        </Route>

        <Route path="/organization/:id/about">
          <DetailAbout />
        </Route>

        <Route path="/organization/:id/program">
          <DetailProgram {...props}/>
        </Route>

        <Route path="/organization/:id/event">
          <DetailEvent />
        </Route>

        <Route path="/organization/:id/resource">
          <DetailResource />
        </Route>

        <Route path="/organization/:id/blog">
          <DetailBlog />
        </Route>

        <Route path="/organization/:id" exact>
          <DetailAbout />
        </Route>
      </OrganizationProvider>
    </DefaultLayout>
  )
}

export { OrganizationDetail }
